<script setup>
import { FormField as PrimeFormField } from '@primevue/forms'

const props = defineProps({
  name: String,
  help: String,
  class: String,
  label: String,
  required: Boolean,
  error: String,
  validateOnValueUpdate: {
    type: [Boolean, Array],
    default: undefined,
  },
  validateOnBlur: {
    type: [Boolean, Array],
    default: undefined,
  },
  validateOnMount: {
    type: [Boolean, Array],
    default: undefined,
  },
  validateOnSubmit: {
    type: [Boolean, Array],
    default: undefined,
  },
})
</script>

<template>
  <PrimeFormField
    v-slot="$field"
    v-bind="{
      name,
      validateOnValueUpdate,
      validateOnBlur,
      validateOnMount,
      validateOnSubmit,
    }"
    :class="['field', props.class]"
    :data-name="name"
  >
    <label class="label" v-if="label">
      <span v-text="label" />
      <sup class="has-text-red" v-if="required">*</sup>
    </label>

    <div class="is-h5 mb-20 content" v-if="$slots.help">
      <slot name="help"></slot>
    </div>

    <slot></slot>

    <p
      class="is-h8 has-text-red mt-5"
      v-if="$field?.invalid && $field.error?.message"
    >
      <span>{{ $field.error?.message }}</span>
    </p>
  </PrimeFormField>
</template>

<style scoped></style>
